module.exports = __webpack_public_path__ + "src/assets/img/cmd-go-service-stop.ce34d891.svg";